export default "__VITE_ASSET__C_$e8DFf__"